import type { FC, ReactElement } from 'react'
import { useState } from 'react'

import { Input } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import EyeOffIcon from 'mdi-react/EyeOffOutlineIcon'
import EyeIcon from 'mdi-react/EyeOutlineIcon'
import { twJoin } from 'tailwind-merge'

import { useTranslation } from '@/app/translations/translations-hooks'
import { useIsThreeStepIT } from '@/hooks/access'

type Props = {
  name?: string
  label?: string | ReactElement
}

const PasswordForm: FC<Props> = ({ name = 'password', label }) => {
  const translate = useTranslation()
  const isThreeStepIT = useIsThreeStepIT()

  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          capitalizeLabel
          id={name}
          type={isPasswordVisible ? 'text' : 'password'}
          ariaLabel={translate('Password')}
          marginBottom={16}
          error={meta.error}
          label={label}
          touched={meta.touched}
          placeholder={translate('Enter your password')}
          RightElement={
            isPasswordVisible ? (
              <Button
                className={twJoin(
                  'm-0 border-none bg-transparent p-0 shadow-none',
                  isThreeStepIT
                    ? 'text-threeStepIT hover:text-threeStepIT-seaMistPrimary-hover active:text-threeStepIT-seaMistPrimary-active focus:text-threeStepIT-seaMistPrimary-active'
                    : 'text-gray-600 hover:text-gray-700',
                  isThreeStepIT &&
                    meta.error &&
                    meta.touched &&
                    'text-threeStepIT-failure hover:text-threeStepIT-failure-hover active:text-threeStepIT-failure-active focus:text-threeStepIT-failure-active'
                )}
                onClick={() => setIsPasswordVisible(false)}
                Icon={<EyeOffIcon className="m-0 w-6" />}
              />
            ) : (
              <Button
                className={twJoin(
                  'm-0 border-none bg-transparent p-0 shadow-none',
                  isThreeStepIT
                    ? 'text-threeStepIT hover:text-threeStepIT-seaMistPrimary-hover active:text-threeStepIT-seaMistPrimary-active focus:text-threeStepIT-seaMistPrimary-active'
                    : 'text-gray-600 hover:text-gray-700',
                  isThreeStepIT &&
                    meta.error &&
                    meta.touched &&
                    'text-threeStepIT-failure hover:text-threeStepIT-failure-hover active:text-threeStepIT-failure-active focus:text-threeStepIT-failure-active'
                )}
                onClick={() => setIsPasswordVisible(true)}
                Icon={<EyeIcon className="m-0 w-6" />}
              />
            )
          }
          {...field}
        />
      )}
    </Field>
  )
}

export default PasswordForm
